import { Stack } from "@mui/material";
import _ from "lodash";
import { CorePipelineOutput, ValidationResult } from "../../interfaces/doc";
import ExtractionDisplay from "./ExtractionDisplay";
import ValidationDisplay from "./ValidationDisplay";

const CoreDisplay: React.FC<{
  coreResult: CorePipelineOutput;
  validation: Record<string, ValidationResult> | undefined | null;
}> = ({ coreResult, validation }) => (
  <>
    {coreResult.extraction && (
      <Stack className="gap-3">
        {Object.entries(coreResult.extraction).map(([ex_id, result]) => (
          <ExtractionDisplay key={ex_id} result={result} />
        ))}
      </Stack>
    )}
    {_.keys(validation).length > 0 && (
      <ValidationDisplay validations={validation!} />
    )}
  </>
);

export default CoreDisplay;
